import React from 'react'
import Text from '../../../../../atoms/Text'

type ActiveResidentProps = {
  activeResidentsCount: number
  activeResidentsChange?: number
  peopleNominative?: string
}

/**
 * Display number of active residents
 * @param activeResidentsCount: number of active residents, which affect the monthly bill
 */
export const ActiveResidents = ({
  peopleNominative = 'Resident',
  activeResidentsCount,
  activeResidentsChange,
}: ActiveResidentProps) => (
  <div style={styles.container}>
    <div>
      <Text as="p1">
        <strong>Active {peopleNominative}:</strong> {activeResidentsCount}
      </Text>
      {activeResidentsChange && (
        <Text as="p2" style={styles.text} color="darkgrey">
          {activeResidentsChange > 0
            ? `+${activeResidentsChange} added this month`
            : `${activeResidentsChange} less than last month`}
        </Text>
      )}
    </div>
    <div>
      <Text as="p1" color="darkgrey">
        Your monthly cost is based on the number of active{' '}
        {peopleNominative.toLowerCase()} and doesn&apos;t include dummy
        profiles. Your price will automatically update when this changes.
      </Text>
    </div>
  </div>
)

const styles = {
  container: { marginBottom: 24 },
  text: { marginLeft: 8 },
}

export default ActiveResidents
